<template>
  <div>
    <div class="">
      <div class="row d-flex flex-column flex-md-row pl-2">
        <div class="col-12 col-md-8">
          <div class="input-group col-12 gap-5 abc flex-column">
            <div class="row mb-1">
              <b-form-radio
                v-model="shippedStatus"
                plain
                name="ups"
                value="destination"
              >
                <h5 class="font-bold">
                  {{ $t("usps.choose_only_destination") }}
                </h5>
              </b-form-radio>
              <b-form-radio
                v-model="shippedStatus"
                plain
                name="ups"
                value="shipped"
                class="ml-2"
              >
                <h5 class="font-bold">
                  {{ $t("usps.choose_shipped_from_state") }}
                </h5>
              </b-form-radio>
            </div>
            <div class="row">
              <div class="position-relative mr-1" style="width: 20rem">
                <span class="input-label font-bold">{{
                  $t("usps.shipping_date_from")
                }}</span>
                <div>
                  <flat-pickr
                    v-model="shippingDateFrom"
                    class="form-control invoice-edit-input invoice-input-top mt-1"
                    :placeholder="fourDaysBeforeCurrentDate"
                    :class="{ 'is-invalid': shippingDateFromInvalid }"
                  />
                  <feather-icon
                    v-if="shippingDateFrom === ''"
                    size="16"
                    icon="CalendarIcon"
                    class="cursor-pointer clear-all mt-cus"
                  />
                  <feather-icon
                    v-else-if="!shippingDateFromInvalid"
                    size="16"
                    icon="XIcon"
                    class="cursor-pointer clear-all mt-cus"
                    @click="shippingDateFrom = ''"
                  />
                </div>
                <div v-if="shippingDateFromInvalid" class="invalid-feedback">
                  Shipping Date From must be less than Shipping Date To.
                </div>
              </div>

              <div class="position-relative mr-1" style="width: 20rem">
                <span class="input-label font-bold">{{
                  $t("usps.shipping_date_to")
                }}</span>
                <div>
                  <flat-pickr
                    v-model="shippingDateTo"
                    class="form-control invoice-edit-input invoice-input-top mt-1"
                    :placeholder="currentDate"
                    :class="{ 'is-invalid': shippingDateToInvalid }"
                  />
                  <feather-icon
                    v-if="shippingDateTo === ''"
                    size="16"
                    icon="CalendarIcon"
                    class="cursor-pointer clear-all mt-cus"
                  />
                  <feather-icon
                    v-else-if="!shippingDateFromInvalid"
                    size="16"
                    icon="XIcon"
                    class="cursor-pointer clear-all mt-cus"
                    @click="shippingDateTo = ''"
                  />
                </div>
                <div v-if="shippingDateToInvalid" class="invalid-feedback">
                  Shipping Date From must be less than Shipping Date To.
                </div>
              </div>

              <div class="position-relative mr-1 py-cus" style="width: 20rem">
                <span class="input-label font-bold">{{
                  $t("usps.delievered_after")
                }}</span>
                <div>
                  <flat-pickr
                    v-model="deliveredBy"
                    class="form-control invoice-edit-input invoice-input-top mt-1"
                    :placeholder="sixDaysAfterCurrentDate"
                  />
                  <feather-icon
                    v-if="deliveredBy === ''"
                    size="16"
                    icon="CalendarIcon"
                    class="cursor-pointer clear-all mtups-cus"
                  />
                  <feather-icon
                    v-else
                    size="16"
                    icon="XIcon"
                    class="cursor-pointer clear-all mtups-cus"
                    @click="deliveredBy = ''"
                  />
                </div>
              </div>
              <div
                v-if="shippedStatus === 'shipped'"
                class="mr-1 pt-2"
                style="width: 20rem"
              >
                <span class="input-label font-bold">{{
                  $t("usps.shipping_state")
                }}</span>
                <select
                  v-model="shipping_state"
                  id="state"
                  :disabled="isDisabled"
                  :placeholder="$t('usps.state')"
                  class="search-product form-control mt-1"
                >
                  <option v-if="!isDisabled" value="" selected>
                    Select a state
                  </option>
                  <option
                    v-for="option in options"
                    :key="option.key"
                    :value="option.key"
                    selected
                  >
                    {{ option.value }}
                  </option>
                </select>
              </div>

              <div class="mr-1 pt-2" style="width: 20rem">
                <span class="input-label font-bold">{{
                  $t("usps.destination_zip")
                }}</span>
                <input
                  v-model="zipCode"
                  type="number"
                  :placeholder="$t('usps.zipCode')"
                  class="search-product form-control mt-1"
                  @input="validateZipCode"
                />
                <span v-if="zipCodeError" class="text-danger">{{
                  zipCodeError
                }}</span>
              </div>

              <div class="mr-1 pt-2" style="width: 20rem">
                <span class="input-label font-bold">{{
                  $t("usps.delivery_city")
                }}</span>
                <input
                  v-model="deliveryCity"
                  type="text"
                  :placeholder="$t('usps.delivery_city')"
                  class="search-product form-control mt-1"
                />

                <div
                  v-if="isDeliveryCityOnlySpaces && deliveryCity"
                  class="text-danger mt-1"
                >
                  {{
                    $t("usps.delivery_city") +
                    " " +
                    $t("usps.no_spaces_allowed")
                  }}
                </div>
              </div>

              <div class="d-flex">
                <b-form-checkbox
                  v-model="show_deliverable"
                  class="custom-control-primary custom-switch-btn mt-4"
                  name="invoiceData.scheduled"
                  :check-status="false"
                >
                  <span class="ml-1 input-label font-bold">
                    {{ $t("usps.show_deleverable") }}</span
                  >
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <b-button
            variant="primary"
            class="float-left mt-2 mb-1 text-capitalize"
            style="margin-right: 15px; height: fit-content"
            :disabled="
              shippedStatus === 'shipped'
                ? shippingDateFrom === '' ||
                  shippingDateTo === '' ||
                  deliveredBy === '' ||
                  zipCode === '' ||
                  zipCodeError ||
                  isLoading
                : shippingDateFrom === '' ||
                  shippingDateTo === '' ||
                  deliveredBy === '' ||
                  zipCode === '' ||
                  zipCodeError ||
                  isLoading
            "
            @click="handleClick"
          >
            <div
              v-if="isLoading"
              class="spinner-border d-flex align-items-center"
              style="height: 16px; width: 16px"
            />
            <div v-else class="">
              <feather-icon
                icon="FilterIcon"
                size="17"
                class="cursor-pointer"
              />
              <span>{{ $t("usps.apply_filters") }}</span>
            </div>
          </b-button>
        </div>
        <div class="col-12 col-md-4">
          <div class="">
            <div
              class="alert alert-primary d-flex align-items-start p-1 rounded shadow-sm"
              role="alert"
              style="
                background-color: #0d1b2a;
                color: #fff;
                border: 1px solid #1e3a8a;
              "
            >
              <img
                src="@/assets/images/icons/alert.svg"
                class="mr-3"
                alt="alert-icon"
                width="32"
                height="32"
              />
              <div>
                <h6 class="mb-2 font-weight-bolder">USP Update</h6>
                <p class="mb-1">
                  When you choose <strong> delivered </strong> trackings you
                  will get only trackings without proof of delivery. Do you can
                  use the safely and with confidence! Choose only delivered!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="no_record_found">
      <div
        class="d-flex flex-direction-column align-items-center justify-content-center"
      >
        <div class="align-items-center justify-content-center">
          <div class="mb-1 start-chat-icon pl-3">
            <feather-icon icon="FolderIcon" size="40" />
          </div>
          <h5 class="sidebar-toggle start-chat-text">
            {{ $t("usps.no_carrier") }}
          </h5>
        </div>
      </div>
    </template>

    <b-table
      v-if="shippignItems.length || destinationItems.length"
      :fields="shippingfields"
      :items="shippedStatus === 'shipped' ? shippignItems : destinationItems"
      responsive
      class="mb-0"
      show-empty
      :empty-text="'no records found'"
      empty-filtered-text
    >
      <template>
        <div class="d-flex align-items-center justify-content-center">
          <div class="mb-1 start-chat-icon">
            <feather-icon icon="FolderIcon" size="40" />
          </div>
          <h5 class="sidebar-toggle start-chat-text">no_record</h5>
        </div>
      </template>

      <template #cell(trackingNumber)="data">
        <!-- {{ trackerNumber[data.item.encode] }} -->
        <div class="d-flex flex-column">
          <span v-if="!trackerNumber[data.item.encode]" class="font-bold">{{
            data.item.trackingNumber
          }}</span>
          <feather-icon
            v-if="!trackerNumber[data.item.encode]"
            icon="EyeIcon"
            size="16"
            class="mt-1 cursor-pointer"
            @click="handleEyeClick(data.item)"
          />
          <!-- <b-tooltip
            :target="'tooltip-button-' + data.item.encode"
            placement="top"
            triggers="hover"
          >
            show
          </b-tooltip> -->
          <a
            v-if="trackerNumber[data.item.encode]"
            class="cursor-pointer font-bold"
            :href="`https://www.ups.com/track?requester=QUIC&tracknum=${
              trackerNumber[data.item.encode]
            }`"
            target="_blank"
            >{{ trackerNumber[data.item.encode] }}</a
          >
          <CopyToClipboard
            ref="copyToClipboardRef"
            :key="trackerNumber[data.item.encode]"
            class="cursor-pointer"
            :text="trackerNumber[data.item.encode]"
            @copy="copyAffiliateLink(trackerNumber[data.item.encode])"
          >
            <feather-icon
              v-if="trackerNumber[data.item.encode]"
              class="mt-1 cursor-pointer"
              :icon="
                copied[data.item.trackingNumber] ? 'CheckIcon' : 'CopyIcon'
              "
              size="14"
            />
          </CopyToClipboard>
        </div>
      </template>

      <template #cell(trackingStatus)="data">
        <div class="font-bold">{{ data.item.trackingStatus }}</div>
      </template>

      <template #cell(shippingDate)="data">
        <div class="font-bold">
          {{
            new Date(data.item.shippingDate).toLocaleString("en-US", {
              dateStyle: "medium",
              timeStyle: "short",
            })
          }}
        </div>
      </template>

      <template #cell(deliveryDate)="data">
        <div class="font-bold">
          {{
            new Date(data.item.deliveryDate).toLocaleString("en-US", {
              dateStyle: "medium",
              timeStyle: "short",
            })
          }}
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BLink,
  BTooltip,
  BFormCheckbox,
  BFormRadio,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import useJwt from "@/auth/jwt/useJwt";
import CopyToClipboard from "vue-copy-to-clipboard";
import { stateOptions } from "./../../utils/states.js";
import axios from "@/libs/axios";

export default {
  components: {
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BLink,
    BTooltip,
    BFormCheckbox,
    BFormRadio,
    flatPickr,
    CopyToClipboard,
    stateOptions,
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        // A virtual column that doesn't exist in items
        {
          key: "period",
          sortable: false,
        },
        // A column that needs custom formatting
        {
          key: "companyName",
          label: "Company Name",
          sortable: false,
        },
        {
          key: "companyMail",
          label: "Email",
          sortable: false,
        },
        {
          key: "status",
          sortable: false,
        },
        // A regular column
        {
          key: "companyOwnerFirstName",
          label: "Owner Name",
          sortable: false,
        },
        // A regular column
        {
          key: "companyIdentificationNumber",
          label: "Company ID",
          sortable: false,
        },

        // A virtual column made up from two fields
      ],
      /* eslint-disable global-require */
      items: [],
      shippingDateFrom: "",
      shippingDateTo: "",
      deliveredBy: "",
      shipping_state: "",
      options: stateOptions,
      zipCode: "",
      deliveryCity: "",
      show_deliverable: false,
      near_by_zip: false,
      shippedStatus: "destination",
      isLoading: false,
      shippignItems: [],
      destinationItems: [],
      shippingfields: [
        {
          key: "trackingNumber",
          label: "Tracking Number",
          // sortable: true,
        },
        {
          key: "trackingStatus",
          label: "Status",
          sortable: true,
        },
        {
          key: "shippingDate",
          label: "Shipping Date",
          // sortable: true,
        },
        {
          key: "shippingCity",
          label: "Shipping City",
          // sortable: true,
        },
        {
          key: "shippingState",
          label: "Shipping State",
          // sortable: true,
        },
        {
          key: "deliveryDate",
          label: "Delivery Date",
          // sortable: true,
        },
        {
          key: "deliveryCity",
          label: "Delivery City",
          // sortable: true,
        },
        {
          key: "weight",
          label: "Weight (kg)",
          // sortable: true,
        },
        {
          key: "zipCode",
          label: "Zip Code",
          // sortable: true,
        },
      ],
      trackerNumber: "",
      copied: {}, // Track copied state
      /* eslint-disable global-require */
      zipCodeError: "",
      no_record_found: false,
      currentUser: {},
      isDisabled: false,
    };
  },
  computed: {
    isDeliveryCityOnlySpaces() {
      return (
        this.deliveryCity.trim() === "" ||
        /^[\s]+[A-Za-z]/.test(this.deliveryCity)
      );
    },
    shippingDateFromInvalid() {
      return (
        this.shippingDateFrom &&
        this.shippingDateTo &&
        new Date(this.shippingDateFrom) >= new Date(this.shippingDateTo)
      );
    },
    shippingDateToInvalid() {
      return (
        this.shippingDateFrom &&
        this.shippingDateTo &&
        new Date(this.shippingDateFrom) >= new Date(this.shippingDateTo)
      );
    },
    currentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    fourDaysBeforeCurrentDate() {
      const date = new Date();
      date.setDate(date.getDate() - 4);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    sixDaysAfterCurrentDate() {
      const date = new Date();
      date.setDate(date.getDate() + 6);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
  mounted() {
    // Set the default value for deliveredBy to ten days before the current date
    this.shippingDateFrom = this.fourDaysBeforeCurrentDate;
    this.shippingDateTo = this.currentDate;
    this.deliveredBy = this.sixDaysAfterCurrentDate;
    this.getUserDetail();
  },
  watch: {
    // shippedStatus() {
    //   this.zipCode = "";
    //   this.zipCodeError = "";
    // },
    // shippingDateTo(newDate) {
    //   if (newDate !== this.deliveredBy) {
    //     this.deliveredBy = newDate;
    //   }
    // },
  },
  methods: {
    async getUserDetail() {
      try {
        const data = await axios.get("account/api/user/who-am-i");
        if (data.data) {
          this.currentUser = data.data;
          if (this.currentUser.shippingStates.length > 0) {
            const data1 = this.currentUser.shippingStates
              .map((item) => ({
                key: item,
                value: this.currentUser.shippingStates.join(", "),
              }))
              .filter(
                (item, index, self) =>
                  index === self.findIndex((t) => t.value === item.value),
              );
            this.isDisabled = true;
            this.options = data1;
            if (this.options.length > 0) {
              this.shipping_state = this.options[0].key; // Set the default value to the first option's key
            }
          }
        }
      } catch (error) {
        console.log("error", error);
        this.isDisabled = false;
      }
    },
    validateZipCode() {
      if (this.zipCode.length > 5) {
        this.zipCode = this.zipCode.slice(0, 5);
      }
      if (this.zipCode.length < 5) {
        this.zipCodeError = "ZIP Code must be exactly 5 digits long.";
      } else {
        this.zipCodeError = "";
      }
    },
    toUpperCase(event) {
      this.shipping_state = event.target.value
        .replace(/[^A-Za-z]/g, "")
        .toUpperCase();
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const year = d.getFullYear();

      return `${month}/${day}/${year}`;
    },
    handleEyeClick(e) {
      const ipAddress = localStorage.getItem("ip") || "";
      let payload = {};
      if (this.shippedStatus === "shipped") {
        payload = {
          searchId: e.searchId,
          number: Number(e.encode),
          ipAddress: ipAddress,
          shippingState: true,
        };
      } else {
        payload = {
          searchId: e.searchId,
          number: Number(e.encode),
          ipAddress: ipAddress,
        };
      }

      const token = useJwt.getToken();
      useJwt
        .DecodeNumber(token, payload)
        .then((response) => {
          const trackingNumber = Object.values(response.data)[0]; // Extracting the value from the response
          this.trackerNumber = {
            ...this.trackerNumber,
            [e.encode]: trackingNumber,
          };
          this.copyAffiliateLink(trackingNumber);
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },

    copyAffiliateLink(trackingNumber) {
      navigator.clipboard.writeText(trackingNumber);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Tracking Number Successfully Copied",
          icon: "CheckIcon",
          variant: "success",
        },
      });
      setTimeout(() => {
        this.$set(this.copied, trackingNumber, false);
      }, 2000); // Show the check icon for 2 seconds
    },
    async handleClick() {
      this.isLoading = true;
      if (this.shippedStatus === "destination") {
        const data = {
          shippingDateFrom: this.formatDate(this.shippingDateFrom),
          shippingDateTo: this.formatDate(this.shippingDateTo),
          deliveredBy: this.formatDate(this.deliveredBy),
          showDelivered: this.show_deliverable,
          zipCode: this.zipCode,
          city: this.deliveryCity?.trim() ? this.deliveryCity : null,
          carrier: "ups",
        };

        try {
          const token = useJwt.getToken();
          const response = await useJwt.UPSByZipCode(token, data);
          this.isLoading = false;
          if (response.data.elements !== "") {
            if (response.data.totalElements === 0) {
              this.no_record_found = true;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `No Record Found. Please Try another Date Range`,
                  icon: "EditIcon",
                  variant: "success",
                },
              });
              this.destinationItems = [];
            } else {
              this.no_record_found = false;
              this.destinationItems = response.data.elements;
            }
          }
        } catch (error) {
          this.isLoading = false;
          console.log("error..", error.error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
      if (this.shippedStatus === "shipped") {
        if (this.shipping_state === "") {
          const data = {
            shippingDateFrom: this.formatDate(this.shippingDateFrom),
            shippingDateTo: this.formatDate(this.shippingDateTo),
            deliveredBy: this.formatDate(this.deliveredBy),
            showDelivered: this.show_deliverable,
            zipCode: this.zipCode,
            city: this.deliveryCity?.trim() ? this.deliveryCity : null,
            carrier: "ups",
          };
          try {
            const token = useJwt.getToken();
            const response = await useJwt.UPSByZipCode(token, data);
            this.isLoading = false;
            if (response.data.elements !== "") {
              if (response.data.totalElements === 0) {
                this.no_record_found = true;
                this.shippignItems = [];
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: `No Record Found. Please Try another Date Range`,
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } else {
                this.no_record_found = false;
                this.shippignItems = response.data.elements;
              }
            }
          } catch (error) {
            this.isLoading = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `${error.response.data.errorMessage}`,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        } else {
          const data1 = {
            shippingDateFrom: this.formatDate(this.shippingDateFrom),
            shippingDateTo: this.formatDate(this.shippingDateTo),
            deliveredBy: this.formatDate(this.deliveredBy),
            shippingState: this.shipping_state,
            showDelivered: this.show_deliverable,
            zipCode: this.zipCode,
            city: this.deliveryCity?.trim() ? this.deliveryCity : null,
            carrier: "ups",
          };
          try {
            const token = useJwt.getToken();
            const response = await useJwt.UPSByShippingState(token, data1);
            this.isLoading = false;
            if (response.data.elements !== "") {
              if (response.data.totalElements === 0) {
                this.no_record_found = true;
                this.shippignItems = [];
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: `No Record Found. Please Try another Date Range`,
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } else {
                this.no_record_found = false;
                this.shippignItems = response.data.elements;
              }
            }
          } catch (error) {
            this.isLoading = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `${error.response.data.errorMessage}`,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.mt-cus {
  margin-top: 10px;
}

.mtups-cus {
  margin-top: 10px;
}

.py-cus {
  padding: 0 0;
}

.font-bold {
  font-weight: 600;
}

@media (max-width: 1652px) {
  .py-cus {
    padding: 1.5rem 0 0 0;
  }
  .mtups-cus {
    margin-top: 20px;
  }
}
</style>
